import React, {Fragment} from 'react';
import {withRouter} from "react-router-dom";
import Foorter from "../common/Footer.jsx";
import MainNav from '../Navs/MainNav.jsx';
import TopNav from '../Navs/TopNav.jsx';
import Header from '../common/Header.jsx';
import Helmet from "react-helmet";


const MainLayout = props => {
   const {pathname} = props.location 
    return ( 
        <>
        <Fragment>
        <Helmet>
          <title>Ciademy/Home</title>
         </Helmet>
        <div className="landing-layer">
        <div className="container">
        <TopNav 
           /*
           ....########..#######..########.....##....##....###....##.....##
           .......##....##.....##.##.....##....###...##...##.##...##.....##
           .......##....##.....##.##.....##....####..##..##...##..##.....##
           .......##....##.....##.########.....##.##.##.##.....##.##.....##
           .......##....##.....##.##...........##..####.#########..##...##.
           .......##....##.....##.##...........##...###.##.....##...##.##..
           .......##.....#######..##...........##....##.##.....##....###...
           */
        />
             {pathname === "/" ? <Header /> : null} 
                </div>
            </div>
         <MainNav 
            /*
            ....##.....##....###....####.##....##....##....##....###....##.....##
            ....###...###...##.##....##..###...##....###...##...##.##...##.....##
            ....####.####..##...##...##..####..##....####..##..##...##..##.....##
            ....##.###.##.##.....##..##..##.##.##....##.##.##.##.....##.##.....##
            ....##.....##.#########..##..##..####....##..####.#########..##...##.
            ....##.....##.##.....##..##..##...###....##...###.##.....##...##.##..
            ....##.....##.##.....##.####.##....##....##....##.##.....##....###...
            */
         />
            <main id="home-page"
          /*
          ........######.....###....########..########...######.
          .......##....##...##.##...##.....##.##.....##.##....##
          .......##........##...##..##.....##.##.....##.##......
          .......##.......##.....##.########..##.....##..######.
          .......##.......#########.##...##...##.....##.......##
          .......##....##.##.....##.##....##..##.....##.##....##
          ........######..##.....##.##.....##.########...######.
          */
            >
            <div className="container">{props.children}</div>
                  </main>
           <Foorter 
           /*
           .########..#######...#######..########.########.########.
           .##.......##.....##.##.....##....##....##.......##.....##
           .##.......##.....##.##.....##....##....##.......##.....##
           .######...##.....##.##.....##....##....######...########.
           .##.......##.....##.##.....##....##....##.......##...##..
           .##.......##.....##.##.....##....##....##.......##....##.
           .##........#######...#######.....##....########.##.....##
           */
            />
        </Fragment>
        </>
     );
}
export default withRouter(MainLayout);